import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';

export const getMyCafeDailyWorkingHours = _ => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.workingHours
        .getMyCafeDailyWorkingHours()
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_MY_CAFE_DAILY_WORKING_HOURS_FAILED,
              reject: actionTypes.GET_MY_CAFE_DAILY_WORKING_HOURS_REJECT
            })
          );
        });
    };
  };

  const loading = () => action(actionTypes.GET_MY_CAFE_DAILY_WORKING_HOURS_LOADING);
  const success = res => action(actionTypes.GET_MY_CAFE_DAILY_WORKING_HOURS_SUCCESS, res);
  return request();
};

export const getMyRseeDailyWorkingHours = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.workingHours
        .getMyRseeDailyWorkingHours(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_MY_RSEE_DAILY_WORKING_HOURS_FAILED,
              reject: actionTypes.GET_MY_RSEE_DAILY_WORKING_HOURS_REJECT
            })
          );
        });
    };
  };

  const loading = () => action(actionTypes.GET_MY_RSEE_DAILY_WORKING_HOURS_LOADING);
  const success = res => action(actionTypes.GET_MY_RSEE_DAILY_WORKING_HOURS_SUCCESS, res);
  return request();
};
